import { useQuery } from 'react-query'
import { getJoinLinkByMoneypoolId } from '../../../../services/fund'

export default function useJoinLink (moneypoolId){
    const { data, isLoading } = useQuery(
        ['moneypool_join_link', moneypoolId],
        getJoinLinkByMoneypoolId
    )
    return { joinLink: data?.join_link || '', isLoadingJoinLink: isLoading }
}